import { createFiltersReducer } from '../utils';
import { ACTIONS_PREFIX } from '../actions/reviewLicenseFilters';

const initialFiltersState = {
    licenseId: '',
    licenseTypeName: '',
    users: [],
    officeIds: [],
    projectIds: [],
    virtualMachines: [],
    infrastructureUnits: [],
    deviceType: '',
    manufacturer: '',
    office: [],
    resourceOwner: [],
    assignmentDateFrom: null,
    assignmentDateTo: null,
    pageNumber: 1,
    itemsPerPage: 10,
    isAppliedFilter: false,
    sortBy: '',
    sortOrder: 'asc',
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const reviewLicenseFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default reviewLicenseFiltersReducer;
